export default "__VITE_ASSET__BHsWhA1M__"